// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"63":"313551b5","397":"569edec1","723":"5419d3c3"}[chunkId] + ".css";
};